import Tooltip from '@material-ui/core/Tooltip';
import { Stomp } from '@stomp/stompjs';
import moment from 'moment';
import React, { Fragment } from 'react';

import { toastError, toastInfo, toastSuccess, toastWarning } from '@components/Toast';

import { getBaseWebSocketUrl } from '@/constants/constant';

import deploymentDetector from '@/services/deploymentDetector';

export const VALID_FILE_SIZE = 150582912;

export const emailRegex =
	/(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/;

const capitalizeFirstLetter = (str) => {
	if (str) {
		return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
	}
	return '';
};

const replaceSpace = (str) => str.split(' ').join('_');

const getAllMonthsList = [
	'January',
	'February',
	'March',
	'April',
	'May',
	'June',
	'July',
	'August',
	'September',
	'October',
	'November',
	'December'
];

const validate = (e, pass = '', passFullCheck = false) => {
	if (e.target.name === 'email') {
		let re =
			/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		if (e.target.value === '') {
			return {
				name: 'emailError',
				value: 'Email is required!'
			};
		} else if (!re.test(e.target.value)) {
			return {
				name: 'emailError',
				value: 'Invalid Email Format!'
			};
		} else {
			return {
				name: 'emailError',
				value: ''
			};
		}
	}
	if (e.target.name === 'password') {
		// if(e.target.value.length<6){
		let re = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}/;
		if (e.target.value === '') {
			return {
				name: 'passwordError',
				value: 'Password is required!'
			};
		} else if (!re.test(e.target.value) && passFullCheck) {
			return {
				name: 'passwordError',
				value: 'Password must contain 6 characters, at least one number, one lowercase and one uppercase letter'
			};
		} else {
			return {
				name: 'passwordError',
				value: ''
			};
		}
	}
	if (e.target.name === 'passwordRe') {
		if (e.target.value !== pass) {
			return {
				name: 'passwordReError',
				value: "Passwords didn't match!"
			};
		} else {
			return {
				name: 'passwordReError',
				value: ''
			};
		}
	}
	if (e.target.name === 'agreement') {
		if (!e.target.checked) {
			return {
				name: 'agreementError',
				value: 'Please accept terms & conditions first!'
			};
		} else {
			return {
				name: 'agreementError',
				value: ''
			};
		}
	}
	if (e.target.name === 'oldPassword') {
		if (e.target.value === '') {
			return {
				name: 'oldPasswordError',
				value: 'Current password is required!'
			};
		} else {
			return {
				name: 'oldPasswordError',
				value: ''
			};
		}
	}
	if (e.target.name === 'newPassword') {
		// if(e.target.value.length<6){
		let re = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}/;
		if (e.target.value === '') {
			return {
				name: 'newPasswordError',
				value: 'Password is required!'
			};
		} else if (!re.test(e.target.value) && passFullCheck) {
			return {
				name: 'newPasswordError',
				value: 'Password must contain 6 characters, at least one number, one lowercase and one uppercase letter'
			};
		} else {
			return {
				name: 'newPasswordError',
				value: ''
			};
		}
	}
	if (e.target.name === 'newPasswordRe') {
		if (e.target.value !== pass) {
			return {
				name: 'newPasswordReError',
				value: "Passwords didn't match!"
			};
		} else {
			return {
				name: 'newPasswordReError',
				value: ''
			};
		}
	}
};

const encodeQueryData = (data) => {
	let ret = [],
		temp;
	for (let i in data) {
		temp = data[i];
		if (temp !== '' && temp !== null) {
			ret.push(encodeURIComponent(i) + '=' + encodeURIComponent(temp));
		}
	}
	return ret.length ? '?' + ret.join('&') : '';
};

const rfqStatus = (item) => {
	switch (item.status) {
		case 'PENDING':
			return (
				<span className="badge table-badge" style={{ backgroundColor: '#FFF1F1', color: '#D53939' }}>
					Pending
				</span>
			);
		case 'OFFER_PENDING':
			return (
				<span className="badge table-badge" style={{ backgroundColor: '#FFF1F1', color: '#D53939' }}>
					Pending
				</span>
			);
		case 'RUNNING':
			return (
				<span className="badge table-badge" style={{ backgroundColor: '#F5EFE4', color: '#D29F27' }}>
					Running
				</span>
			);
		case 'COMPLETED':
			return (
				<span className="badge table-badge" style={{ backgroundColor: '#E4F6EA', color: '#35D575' }}>
					Completed
				</span>
			);
		default:
			return <></>;
	}
};

const rfqProductStatus = (item) => {
	switch (item.status) {
		case 'OFFER_PENDING':
			return (
				<span className="badge table-badge" style={{ backgroundColor: '#F0EDF7', color: '#452D8F' }}>
					Offer Pending
				</span>
			);

		case 'PRICE_GIVEN':
			return (
				<span className="badge table-badge" style={{ backgroundColor: '#F5EFE4', color: '#D29F27' }}>
					Quoted
				</span>
			);

		case 'APPROVED':
			return (
				<span className="badge table-badge" style={{ backgroundColor: '#E4F6EA', color: '#35D575' }}>
					Approved
				</span>
			);

		case 'PRODUCT_SOLD':
			return (
				<span className="badge table-badge" style={{ backgroundColor: '#FFE6E6', color: '#F22B2B' }}>
					Design Sold
				</span>
			);

		case 'ORDER_PLACED':
			return (
				<span className="badge table-badge" style={{ backgroundColor: '#DBFFE5', color: '#00C334' }}>
					Order Placed
				</span>
			);

		default:
			return <></>;
	}
};

const projectStatus = (item) => {
	switch (item.status) {
		case 'PENDING':
			return (
				<span className="badge table-badge" style={{ backgroundColor: '#FFF1F1', color: '#D53939' }}>
					Pending
				</span>
			);
		case 'RUNNING':
			return (
				<span className="badge table-badge" style={{ backgroundColor: '#F5EFE4', color: '#D29F27' }}>
					Running
				</span>
			);
		case 'COMPLETED':
			return (
				<span className="badge table-badge" style={{ backgroundColor: '#E4F6EA', color: '#35D575' }}>
					Completed
				</span>
			);
		default:
			return <></>;
	}
};

const _getKey = () => {
	return Math.floor(Math.random() * 10000000) + Math.floor(Math.random() * 10000000);
};

const clothingLabelStatus = (status) => {
	switch (status) {
		case 'DONT_HAVE_LABEL_YET':
			return (
				<span
					className="badge table-badge"
					style={{ backgroundColor: '#F5EFE4', color: '#D29F27', fontWeight: 'bold' }}
				>
					No! Don&apos;t have a label yet
				</span>
			);
		case 'WE_HAVE_A_PRIVATE_CLOTHING_LABEL':
			return (
				<span
					className="badge table-badge"
					style={{ backgroundColor: '#F5EFE4', color: '#D29F27', fontWeight: 'bold' }}
				>
					Yes, we have a private clothing label
				</span>
			);
		case 'DO_DROPSHIP_ONLY':
			return (
				<span
					className="badge table-badge"
					style={{ backgroundColor: '#F5EFE4', color: '#D29F27', fontWeight: 'bold' }}
				>
					We do drop-shipping only
				</span>
			);
		case 'DROPSHIP_NOW_WILL_BUILD_LABEL':
			return (
				<span
					className="badge table-badge"
					style={{ backgroundColor: '#F5EFE4', color: '#D29F27', fontWeight: 'bold' }}
				>
					We dropship now, will build label
				</span>
			);
		case 'SELL_WHOLESALE_TO_RETAILERS':
			return (
				<span
					className="badge table-badge"
					style={{ backgroundColor: '#F5EFE4', color: '#D29F27', fontWeight: 'bold' }}
				>
					We sell wholesale to retailers
				</span>
			);
		case 'MAKE_PROMOTIONAL_GOODS':
			return (
				<span
					className="badge table-badge"
					style={{ backgroundColor: '#F5EFE4', color: '#D29F27', fontWeight: 'bold' }}
				>
					We make promotional goods
				</span>
			);
		default:
			return 'N/A';
	}
};

const addImageSuffix = (imgUrl) => {
	return imgUrl;
};

const getImageExt = (url) => {
	if (!url) {
		return '';
	}

	let splits = url.split('.');
	let result = '';
	if (splits.length) {
		result = splits[splits.length - 1];
	}
	return result;
};

const IMAGE_EXTS = [
	'jpeg',
	'jpg',
	'png',
	'gif',
	'tiff',
	'svg',
	'JPEG',
	'JPG',
	'PNG',
	'GIF',
	'TIFF',
	'SVG',
	'webp'
];
const DOC_EXTS = ['doc', 'docx', 'DOC', 'DOCX'];
const XLS_EXTS = ['xls', 'xlsx', 'XLS', 'XLSX'];
const PDF_EXTS = ['pdf', 'PDF'];
const AI_EXTS = ['ai', 'AI'];
const PSD_EXTS = ['ps', 'psd', 'PS', 'PSD'];
const EPS_EXTS = ['eps', 'EPS'];

const checkFileExtention = (file) => {
	let ext = file?.name?.split('.').pop();
	return !IMAGE_EXTS.includes(ext);
};

const getFileType = (fileName) => {
	if (!fileName || fileName.trim().length === 0) return 'NO_FILE';
	let ext = fileName.split('.').pop();

	if (IMAGE_EXTS.includes(ext)) return 'IMAGE';
	else if (DOC_EXTS.includes(ext)) return 'DOC';
	else if (XLS_EXTS.includes(ext)) return 'XLX';
	else if (PDF_EXTS.includes(ext)) return 'PDF';
	else if (AI_EXTS.includes(ext)) return 'AI';
	else if (PSD_EXTS.includes(ext)) return 'PSD';
	else if (EPS_EXTS.includes(ext)) return 'EPS';
	else return 'FILE';
};

const replaceUnderLine = (str = '', isCapital = false) => {
	if (typeof str !== 'string') {
		return '';
	}
	return !isCapital ? capitalizeFirstLetter(str.split('_').join(' ')) : str.split('_').join(' ');
};

const sizeInMB = (sizeInBytes) => {
	if (sizeInBytes == null) return '0.00';
	return (sizeInBytes / (1024 * 1024)).toFixed(2);
};

const isValidFile = (file, type, validSize = VALID_FILE_SIZE) => {
	let ext = file.name.split('.').pop();

	if (type === 'PRODUCT_DESIGN' || type === 'REFERENCE_IMAGE' || type === 'IMAGE') {
		if (IMAGE_EXTS.includes(ext) && file.size < validSize) {
			return true;
		} else {
			toastWarning('Please ensure proper extension of the file');
		}
	} else if (type === 'image') {
		if (!IMAGE_EXTS.includes(ext)) {
			toastWarning('Please ensure proper extension of the file');
		} else if (file.size > validSize) {
			toastWarning(`Please upload file less than ${sizeInMB(validSize)} mb`);
		} else {
			return true;
		}
	} else if (type === 'imageAndPdf') {
		if (!(IMAGE_EXTS.includes(ext) || PDF_EXTS.includes(ext))) {
			toastWarning('Please ensure proper extension of the file');
		} else if (file.size > validSize) {
			toastWarning(`Please upload file less than ${sizeInMB(validSize)} mb`);
		} else {
			return true;
		}
	} else if (type === 'psd') {
		if (ext === 'psd' && file.size < validSize) {
			return true;
		} else {
			toastWarning('Please ensure proper extension of the file');
		}
	} else {
		if (
			(IMAGE_EXTS.includes(ext) ||
				ext === 'xls' ||
				ext === 'xlsx' ||
				ext === 'docx' ||
				ext === 'doc' ||
				ext === 'eps' ||
				ext === 'ai' ||
				ext === 'pdf' ||
				ext === 'ppt' ||
				ext === 'exe' ||
				ext === 'pptx' ||
				ext === 'dxf') &&
			file.size < validSize
		) {
			return true;
		} else {
			toastWarning('Please ensure proper extension of the file');
		}
	}
	return false;
};

const isValidJSON = (str) => {
	try {
		JSON.parse(str);
		return true;
	} catch {
		return false;
	}
};

const convertTimeToLocal = (date, time = '', outputFormat = 'DD.MM.YYYY') => {
	let formatForUtc = moment(date, 'DD/MM/YYYY').format('MM/DD/YYYY') + (time ? ' ' + time : '');
	let convertedDate = moment.utc(formatForUtc).format();
	return moment.utc(convertedDate).local().format(outputFormat);
};

const convertDateTimeToLocal = (date, time = '', outputFormat = 'DD.MM.YYYY') => {
	let gmtDateTime = moment.utc(`${date} ${time}`);
	return gmtDateTime.local().format(outputFormat);
};

const convertDateToLocal = (date, outputFormat = 'DD.MM.YYYY') => {
	return moment.utc(date).local().format(outputFormat);
};

const onGetLocalFromUtc = (utcTime, outputFormat = 'YYYY-MM-DD HH:mm:ss') => {
	return moment.utc(utcTime).local().format(outputFormat);
};

const getMinsCountFromNow = (dateTime, format) => {
	let res = moment().valueOf() - moment(dateTime, format).valueOf();
	if (res) {
		return parseInt(res / (1000 * 60));
	}
	return 0;
};

const getTimeCount = (mins, createdAt, showYear = false) => {
	let hrs = parseInt(mins / 60);
	let today = moment();
	let yesterday = moment().subtract(1, 'day');

	if (mins < 1) {
		return `JUST NOW`;
	} else if (mins < 60) {
		return `${parseInt(mins)}M AGO`;
	} else if (mins < 720) {
		return `${hrs}H AGO`;
	} else if (moment(createdAt).isSame(today, 'day')) {
		return `TODAY AT ${changeDateFormat(createdAt, '', 'h:mm a')}`;
	} else if (moment(createdAt).isSame(yesterday, 'day')) {
		return `YESTERDAY AT ${changeDateFormat(createdAt, '', 'h:mm a')}`;
	} else {
		if (createdAt !== undefined && createdAt !== null) {
			return `${changeDateFormat(
				createdAt,
				'',
				showYear ? 'DD MMM YYYY' : `DD MMM`
			)} AT ${changeDateFormat(createdAt, '', 'h:mm a')}`;
		}
	}
};

const getCollectionTimeCount = (createdAt) => {
	const seconds = Math.floor(
		(new Date() - new Date(changeDateFormat(createdAt, 'DD/MM/YYYY', 'YYYY-MM-DD'))) / 1000
	);
	const years = Math.floor(seconds / 31536000);
	const months = Math.floor(seconds / 2592000);
	const days = Math.floor(seconds / 86400);
	const hours = Math.floor(seconds / 3600);

	if (days > 548) {
		return years > 1 ? years + ' YEARS' : years + ' YEAR';
	} else if (days >= 320 && days <= 547) {
		return '1 YEAR';
	} else if (days >= 45 && days <= 319) {
		return months > 1 ? months + ' MONTHS' : months + ' MONTH';
	} else if (days >= 26 && days <= 45) {
		return '1 MONTH';
	} else if (hours >= 36 && days <= 25) {
		return days > 1 ? days + ' DAYS' : days + ' DAY';
	} else if (hours >= 22 && hours <= 35) {
		return '1 DAY';
	} else {
		return 'TODAY';
	}
};

const changeDateFormat = (date, currentFormat = 'DD/MM/YYYY', newFormat = 'Do MMM, YY') => {
	if (date === undefined) return;
	return moment(date, currentFormat).format(newFormat);
};

const getDaysAgo = (date, currentFormat = 'DD/MM/YYYY') => {
	if (date === undefined) return;
	return moment(date, currentFormat).fromNow();
};

const dateOrder = (order) => {
	if (order === 1) {
		return 'st';
	} else if (order === 2) {
		return 'nd';
	} else if (order === 3) {
		return 'rd';
	} else {
		return 'th';
	}
};

const getDateDifference = (startDate = moment(), endDate, unitOfTime = 'days') => {
	const dateA = moment(startDate);
	const dateB = moment(endDate);
	return dateB.diff(dateA, unitOfTime);
};

const parseHtml = (text) => {
	return text;
};

const valuesAllowed = [
	'0',
	'1',
	'2',
	'3',
	'4',
	'5',
	'6',
	'7',
	'8',
	'9',
	'Backspace',
	'ArrowRight',
	'ArrowLeft'
];

const validateNumber = (e) => {
	if (!valuesAllowed.includes(e.key)) {
		e.preventDefault();
	}
};

const validateFloatNumber = (e) => {
	const values = [...valuesAllowed, '.'];
	if (!values.includes(e.key)) {
		e.preventDefault();
	}
};

const getShortName = (source, size = 35) => {
	return source?.length > size ? source?.slice(0, size - 1) + '…' : source;
};

const getNumberUnit = (value, isShowDollarSign = false, removeFloating = false) => {
	if (value < 1e3) return convertNumberToUSFormat(value, removeFloating, isShowDollarSign);
	if (value >= 1e3 && value < 1e6)
		return convertNumberToUSFormat(+(value / 1e3), removeFloating, isShowDollarSign) + 'K';
	if (value >= 1e6 && value < 1e9)
		return convertNumberToUSFormat(+(value / 1e6), removeFloating, isShowDollarSign) + 'M';
	if (value >= 1e9 && value < 1e12)
		return convertNumberToUSFormat(+(value / 1e9), removeFloating, isShowDollarSign) + 'B';
	if (value >= 1e12)
		return convertNumberToUSFormat(+(value / 1e12), removeFloating, isShowDollarSign) + 'T';
};

const generateFilterOptions = (items) => {
	let params = {};
	items.forEach((item) => {
		if (item.type === 'dateRange') {
			if (params[item.paramName1]) {
				params[item.paramName1] += `,${item.value1 ?? ''}`;
			} else {
				params[item.paramName1] = `${item.value1 ?? ''}`;
			}
			if (params[item.paramName2]) {
				params[item.paramName2] += `,${item.value2 ?? ''}`;
			} else {
				params[item.paramName2] = `${item.value2 ?? ''}`;
			}
		} else {
			if (params[item.paramName]) {
				params[item.paramName] += `,${item.value}`;
			} else {
				params[item.paramName] = `${item.value}`;
			}
		}
	});
	return params;
};

const getUserInfo = () => {
	let userInfo = localStorage.getItem('userInfo');
	if (userInfo) {
		userInfo = JSON.parse(userInfo);
		return userInfo;
	} else {
		return null;
	}
};

const isValidURL = (string) => {
	const res = string.match(
		/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)/g
	);
	return res !== null;
};

const isValidEmail = (email) => {
	return emailRegex.test(email);
};

const getIconByFileType = (fileType) => {
	let publicUrl = process.env.PUBLIC_URL;
	switch (fileType) {
		case 'DOC':
			return `${publicUrl}/images/file-doc.svg`;
		case 'XLX':
			return `${publicUrl}/images/file-xls.svg`;
		case 'PDF':
			return `${publicUrl}/images/file-pdf.svg`;
		case 'AI':
			return `${publicUrl}/images/file-ai.svg`;
		case 'PSD':
			return `${publicUrl}/images/file-ps.svg`;
		case 'EPS':
			return `${publicUrl}/images/file-eps.svg`;
		case 'FILE':
			return `${publicUrl}/images/file.svg`;
		default:
			return `${publicUrl}/images/file.svg`;
	}
};

const openNewWindow = (url) => {
	if (url) {
		if (url.indexOf('_xthumbnail') !== -1) {
			url = url.replace('_xthumbnail', '');
		}
		window.open(url);
	}
};

const checkPasswordStrength = (value) => {
	let percentage = 0;
	if (/\d/.test(value)) {
		percentage += 25;
	}
	if (/(?=.*[A-Z])/.test(value)) {
		percentage += 25;
	}
	if (value.length > 5) {
		percentage += 50;
	}
	let passStrengthObj = {};
	if (percentage < 50) {
		passStrengthObj = {
			percentage: percentage,
			color: 'red',
			text: 'Weak'
		};
	} else if (percentage < 75) {
		passStrengthObj = {
			percentage: percentage,
			color: 'yellow',
			text: 'Medium'
		};
	} else {
		passStrengthObj = {
			percentage: percentage,
			color: 'green',
			text: 'Strong'
		};
	}
	return passStrengthObj;
};

const parseQuoteName = (type) => {
	switch (type) {
		case 'DESIGNWISE':
			return 'Designwise';
		case 'SIZEWISE':
			return 'Sizewise';
		case 'COLORWISE':
			return 'Colorwise';
		case 'SIZE_COLOR_WISE':
			return 'Size & colorwise';
		case 'NOT_AVAILABLE':
			return 'Not available';
		default:
			return '';
	}
};

const checkSingular = (title, value = 0) => {
	if (parseInt(value) > 1) {
		return `${value + ' ' + title}s`;
	}
	return value + ' ' + title;
};

const findHeadingMaxLength = (item) => {
	let className = '';
	if (item.colorWiseSizeQuantityPairList && item.colorWiseSizeQuantityPairList.length > 0) {
		let isValueLargerThanFour =
			item.colorWiseSizeQuantityPairList[0].sizeQuantityPairList.filter(
				(item) => item?.code?.length > 4
			).length > 0;
		className = isValueLargerThanFour ? 'multiple-sizes-table' : '';
	}
	return className;
};

const isPageReachBottom = (element = null) => {
	let bool = false;

	if (element) {
		// For custom scrollable containers
		const { scrollTop, scrollHeight, clientHeight } = element;
		if (Math.abs(Math.ceil(scrollTop + clientHeight) - Math.ceil(scrollHeight)) <= 3) {
			bool = true;
		}
	} else {
		// For document/window scrolling
		const windowHeight =
			'innerHeight' in window ? window.innerHeight : document.documentElement.offsetHeight;
		const html = document.documentElement;
		const windowBottom = windowHeight + window.pageYOffset;
		if (Math.abs(Math.ceil(windowBottom) - Math.ceil(html.scrollHeight)) <= 3) {
			bool = true;
		}
	}

	return bool;
};

const renderMultiColor = (color, isShowColorDetails = false) => {
	if (color.representedBy === 'SWATCH') {
		return (
			<div className="colors-row">
				<div className="multicolors swatch-color">
					<Tooltip title={color?.name} placement="top" arrow>
						<span className="color-icon cursor-pointer">
							<img src={color?.swatchDocResponse?.docUrl} alt={'swatch color'} />
						</span>
					</Tooltip>
					{isShowColorDetails && <span className="ml-2 pl-1">{color?.name}</span>}
				</div>
			</div>
		);
	} else if (color.colorType !== 'SOLID') {
		return (
			<div className="colors-row">
				<div className="multicolors">
					{color?.compositeColorList?.length > 0 &&
						color.compositeColorList.map((item, index) => {
							return (
								<>
									<Tooltip title={color?.name} placement="top" arrow>
										<span
											key={`multi_color_${index}`}
											className="color-icon cursor-pointer"
											style={{ background: item.hexCode }}
										></span>
									</Tooltip>
								</>
							);
						})}
					{color?.compositeColorList?.length === 0 && (
						<div className="d-flex align-items-center">
							<span>{color.name}</span>
						</div>
					)}
					{isShowColorDetails && (
						<p>
							<span>{color?.code}</span>
							<span>{color?.name}</span>
						</p>
					)}
				</div>
			</div>
		);
	} else {
		return (
			<div className="colors-row">
				<div className="multicolors">
					<>
						<Tooltip title={color?.name} placement="top" arrow>
							<span
								className="color-icon cursor-pointer"
								style={{ background: color.hexCode }}
							></span>
						</Tooltip>
						{isShowColorDetails && (
							<p>
								<span>{color?.code}</span>
								<span>{color?.name}</span>
							</p>
						)}
					</>
				</div>
			</div>
		);
	}
};

const downloadBlobFIle = (response) => {
	const [, filename] = response.headers['content-disposition'].split('filename=');
	const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/octet-stream' }));
	const link = document.createElement('a');
	link.href = url;
	link.setAttribute('download', filename); //or any other extension
	document.body.appendChild(link);
	link.click();
};

const buildFile = (file, e, docType, onFileUploaded) => {
	if (file) {
		if (isValidFile(file, file?.type, VALID_FILE_SIZE)) {
			let data = {
				name: file?.name,
				docMimeType: file?.type,
				documentType: docType,
				base64Str: ''
			};
			if (e.id) {
				data.id = e.id;
			}
			let reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = () => {
				data.base64Str = reader.result;
				onFileUploaded(data);
			};
			reader.onerror = function (error) {
				toastError(error);
			};
		} else {
			toastWarning(`Please upload file less than ${sizeInMB(VALID_FILE_SIZE)} mb`);
		}
	}
};

const onUploadFile = (e, docType, onFileUploaded, uploadType = 'SINGLE') => {
	if (uploadType === 'SINGLE') {
		let file = e.target.files[0];
		buildFile(file, e, docType, onFileUploaded);
	} else {
		let oldObj = { ...e.target.files };
		let arr = [];
		Object.keys(oldObj).map((item) => {
			arr.push(oldObj[item]);
		});

		arr.map((file) => {
			buildFile(file, e, docType, onFileUploaded);
		});
	}
};

const generateRandomString = () => Math.random().toString(36).slice(2);

const toOrdinalSuffix = (num) => {
	const int = parseInt(num),
		digits = [int % 10, int % 100],
		ordinals = ['st', 'nd', 'rd', 'th'],
		oPattern = [1, 2, 3, 4],
		tPattern = [11, 12, 13, 14, 15, 16, 17, 18, 19];
	return oPattern.includes(digits[0]) && !tPattern.includes(digits[1])
		? int + ordinals[digits[0] - 1]
		: int + ordinals[3];
};

const showTwoDecimalNumber = (number) => {
	return number === 0 ? '0.00' : !number ? '' : parseFloat(number).toFixed(2);
};

const renderSwatchTypeColorsVertically = (value) => {
	return (
		<Tooltip title={value.name} placement="top" arrow className="cursor-pointer">
			<img src={value?.docUrl || value?.swatchDocResponse?.docUrl} className="color-icon" />
		</Tooltip>
	);
};

const renderPantoneTypeColorsVertically = (value) => {
	if (value?.compositeColorList?.length > 0) {
		return (
			<div className="colors-row">
				<div className="multicolors">
					{value?.compositeColorList.map((color) => (
						<Fragment key={color.id}>
							<Tooltip title={value.name} placement="top" arrow className="cursor-pointer">
								<span className="color-icon" style={{ background: color.hexCode }} />
							</Tooltip>
						</Fragment>
					))}
				</div>
			</div>
		);
	} else
		return (
			<Tooltip title={value.name} placement="top" arrow className="cursor-pointer">
				<div>
					{['SOLID'].includes(value.colorType) && (
						<span
							className="color-icon"
							style={{
								background: value?.hexCode
							}}
						/>
					)}
					{['MULTI', 'AOP', 'YARN_DYED'].includes(value.colorType) && (
						<div className="d-flex align-items-center">
							<span>{value.name}</span>
						</div>
					)}
				</div>
			</Tooltip>
		);
};

const renderSwatchTypeColorsHorizontally = (value, onRemoveColor, requestFrom) => {
	return (
		<div className="solid-colors d-flex">
			<Tooltip title={value.name} placement="top" arrow className="cursor-pointer">
				<div className={`sinlge-group ${requestFrom === 'collections' ? 'disable-hover' : ''}`}>
					<img src={value?.docUrl || value?.swatchDocResponse?.docUrl} className="color-icon" />

					<span>
						<img
							src={`${process.env.PUBLIC_URL}/icons/delete24.svg`}
							alt
							onClick={() => onRemoveColor(value.id)}
						/>
					</span>
				</div>
			</Tooltip>
		</div>
	);
};

const renderPantoneTypeColorsHorizontally = (value, onRemoveColor, requestFrom) => {
	if (value?.compositeColorList?.length > 0) {
		return (
			<div className="colors-row">
				<Tooltip title={value?.name} placement="top" arrow className="cursor-pointer">
					<div className={`multicolors ${requestFrom === 'collections' ? 'disable-hover' : ''}`}>
						{value?.compositeColorList.map((color, index) => (
							<span
								key={`color_${index}`}
								className="color-icon"
								style={{ background: color?.hexCode }}
							/>
						))}
						<span>
							<img
								src={`${process.env.PUBLIC_URL}/icons/delete24.svg`}
								alt
								onClick={() => onRemoveColor(value.id)}
							/>
						</span>
					</div>
				</Tooltip>
			</div>
		);
	} else
		return (
			<div className="solid-colors d-flex">
				<Tooltip title={value?.name} placement="top" arrow className="cursor-pointer">
					<div className={`sinlge-group ${requestFrom === 'collections' ? 'disable-hover' : ''}`}>
						{['SOLID'].includes(value.colorType) && (
							<span
								className="color-icon"
								style={{
									background: value?.hexCode
								}}
							/>
						)}
						{['MULTI', 'AOP', 'YARN_DYED'].includes(value.colorType) && (
							<div className="d-flex align-items-center">
								<span>{value.name}</span>
							</div>
						)}
						<span>
							<img
								src={`${process.env.PUBLIC_URL}/icons/delete24.svg`}
								alt
								onClick={() => onRemoveColor(value.id)}
							/>
						</span>
					</div>
				</Tooltip>
			</div>
		);
};

const onErrorImageLoad = async (e, url, type = 'user') => {
	let image;
	if (e.target.src && e.target.src !== url) image = addImageSuffix(url, '');
	else {
		image = `${process.env.PUBLIC_URL}/images/default_product.svg`;
		if (type === 'user') {
			image = `${process.env.PUBLIC_URL}/images/pro_pic_default.svg`;
		}
	}
	e.target.src = image;
	e.target.onerror = null;
};

const formatNumber = (value, removeFloating = false) => {
	const formatter = new Intl.NumberFormat('en-US', {
		minimumFractionDigits: 0,
		maximumFractionDigits: removeFloating ? 0 : 2
	});

	return formatter.format(removeFloating ? Math.floor(value) : value);
};

export const getNumberUnitForPCS = (value, removeFloating = false) => {
	if (value === null || value === undefined) return;

	if (value < 1e3) return formatNumber(value, removeFloating);
	if (value < 1e6) return `${formatNumber(value / 1e3, removeFloating)}K`;
	if (value < 1e9) return `${formatNumber(value / 1e6, removeFloating)}M`;
	if (value < 1e12) return `${formatNumber(value / 1e9, removeFloating)}B`;

	return `${formatNumber(value / 1e12, removeFloating)}T`;
};

const convertNumberToUSFormat = (value, removeFloating = false, isShowDollarSign = false) => {
	if (!value && value !== 0) return;

	let formatter;
	if (removeFloating) {
		formatter = new Intl.NumberFormat('en-us');
		return `${isShowDollarSign && value ? '$' : ''}${formatter.format(Math.floor(value))}`;
	} else {
		formatter = new Intl.NumberFormat('en-us', {
			minimumFractionDigits: 0,
			maximumFractionDigits: 2
		});
		return `${isShowDollarSign && value ? '$' : ''}${formatter.format(value)}`;
	}
};

const onPreventDefaultAll = (event, activeElement, targetRef) => {
	if (event.key === 'Tab') {
		const inputIsFocused = activeElement === targetRef;
		if (inputIsFocused) {
			event.preventDefault();
		}
	}
};

const getMentionedUserIds = (post, memberList) => {
	memberList = memberList.map((member) => {
		return {
			...member,
			id: member?.memberId ? member.memberId : member.id
		};
	});
	let foundEmails = [];
	let match = null;
	let ids = [];
	while ((match = emailRegex.exec(post))) {
		foundEmails.push(match[0]);
		post = post.replace(match[0], '');
	}
	foundEmails.map((email) => {
		memberList.map((member) => {
			if (member.email === email && !ids.includes(member.id)) {
				ids.push(member.id);
			}
		});
	});
	return ids;
};

const mentionModule = (memberList, bool) => {
	if (bool) return null;
	if (!bool) {
		return {
			allowedChars: /^[A-Za-z\s]*$/,
			mentionDenotationChars: ['@'],
			source: function (searchTerm, renderList, mentionChar) {
				if (mentionChar !== '@') return;
				const values = memberList;

				if (searchTerm.length === 0) {
					renderList(values, searchTerm);
				} else {
					const matches = [];
					for (let i = 0; i < values.length; i++)
						if (~values[i].value.toLowerCase().indexOf(searchTerm.toLowerCase()))
							matches.push(values[i]);
					renderList(matches, searchTerm);
				}
			}
		};
	}
};

const getDefaultMention = (value, memberId) => {
	return `<p><a href="${memberId}" class="wysiwyg-mention" data-mention="" data-value="${value}">@${value}</a>&nbsp;</p>`;
};

const designToolRequiredTools = {
	select: true,
	line: true,
	curves: true,
	draw: true,
	textBox: true,
	upload: true,
	canvasSettings: true,
	crop: true,
	lineArrow: true,
	multipleCanvas: true,
	shape: true,
	singleLine: true,
	comment: true
};

const onImageLoadError = (e) => {
	e.target.onerror = null;
	e.target.src = `${process.env.PUBLIC_URL}/images/noImage.png`;
};

const checkUserType = (userType) => {
	let allUserTypes = JSON.parse(localStorage.getItem('userInfo'))?.allUserTypes;
	return allUserTypes?.includes(userType);
};

const isPatternMaster = () => {
	return checkUserType('PATTERN_MASTER');
};

const isFashionDesigner = () => checkUserType('FASHION_DESIGNER');

const isSampleOrProductHead = () => {
	return checkAnyUserType(['SAMPLE_DEVELOPMENT', 'PRODUCT_DEVELOPMENT']);
};

const isRequestFromSample = () => {
	let params = new URLSearchParams(window.location.search).get('requestFrom');
	return params !== null && params === 'photography';
};

const isRequestFromCosting = () => {
	let params = new URLSearchParams(window.location.search).get('requestFrom');
	return params !== null && params === 'costing';
};

const isRequestFromPhotography = () => {
	let params = new URLSearchParams(window.location.search).get('requestFrom');
	return params !== null && params === 'photography';
};

const getSampleStatus = (status) => {
	switch (status) {
		case 'COSTING':
			return <span className="status costing">{replaceUnderLine(status)}</span>;
		case 'DELIVERED':
			return <span className="status complete">{replaceUnderLine(status)}</span>;
		case 'PHOTOSHOOT':
			return <span className="status photoshoot">{replaceUnderLine(status)}</span>;
		case 'PUBLISHED':
			return <span className="status complete">{replaceUnderLine(status)}</span>;
		default:
			return <span className="status">{replaceUnderLine(status)}</span>;
	}
};

const showDesignViewPage = (product) => {
	return (
		product?.extraFlag?.isArtBoardCreated === true ||
		(product?.extraFlag?.photographyUpdated?.includes('FRONT_IMAGE') &&
			product?.extraFlag?.photographyUpdated?.includes('BACK_IMAGE'))
	);
};

const ACCESS_TOKEN = () => localStorage.getItem('token') && localStorage.getItem('token').split(' ')[1];

const getStompCLient = () => Stomp.client(getBaseWebSocketUrl());

const isValidInput = (prevTarget, event) => {
	return prevTarget.current !== event.target.value;
};

const checkAnyUserType = (userTypes) => {
	let allUserTypes = JSON.parse(localStorage.getItem('userInfo'))?.allUserTypes;
	for (let i = 0; i < userTypes.length; i++) {
		if (allUserTypes?.includes(userTypes[i])) {
			return true;
		}
	}
	return false;
};

const checkHasUserType = (searchUserTypes, allUserTypes) => {
	for (let i = 0; i < searchUserTypes.length; i++) {
		if (allUserTypes?.includes(searchUserTypes[i])) {
			return true;
		}
	}
	return false;
};

const addDataToArrayIndex = (array, index, newItem) => {
	return [...array.slice(0, index), newItem, ...array.slice(index)];
};

const isDirector = () => {
	return (
		getUserInfo()?.isManagement === true &&
		(getUserInfo().managementLevel === 'DIRECTOR' || getUserInfo().managementLevel === 'COUNTRY_HEAD')
	);
};

const isCRMManagement = () => {
	return (
		checkUserType('ADMIN') ||
		(getUserInfo()?.isManagement === true && getUserInfo()?.managementLevel === 'CXO')
	);
};

const isAccountManager = () => {
	return getUserInfo()?.primaryUserType === 'ACCOUNT_MANAGER' && !getUserInfo()?.isManagement;
};
const isCRMAdmin = () => {
	return getUserInfo()?.primaryUserType === 'ADMIN' && !getUserInfo()?.isManagement;
};
const isAdmin = () => {
	return getUserInfo()?.primaryUserType === 'ADMIN';
};
const getPrimaryUserType = () => getUserInfo()?.primaryUserType;

const checkPrimaryUserType = (userType) => getPrimaryUserType() === userType;

const crmTabs = {
	DASHBOARD: 'DASHBOARD',
	GLOBAL_SALES_ANALYSER: 'GLOBAL_SALES_ANALYSER',
	SALES_PERFORMANCE: 'SALES_PERFORMANCE',
	PROJECTION: 'PROJECTION',
	GLOBAL_PROJECTION: 'GLOBAL_PROJECTION',
	PROJECTION_HISTORY: 'PROJECTION_HISTORY',
	BRANDS: 'BRANDS',
	BUYING_CYCLE: 'BUYING_CYCLE',
	TARGET: 'TARGET',
	CONFIGURATION: 'CONFIGURATION',
	SALES_FUNNEL: 'SALES_FUNNEL'
};

const getUserPreference = () => {
	let userInfo = localStorage.getItem('userInfo');
	if (userInfo) {
		try {
			userInfo = JSON.parse(userInfo);
			return userInfo?.systemPreference?.value
				? JSON.parse(userInfo.systemPreference.value)
				: userInfo.systemPreference;
		} catch {
			return {};
		}
	} else {
		return null;
	}
};

const getSurveySettings = () => {
	let userInfo = localStorage.getItem('userInfo');
	if (userInfo) {
		userInfo = JSON.parse(userInfo);
		return userInfo?.surveySettings?.value
			? JSON.parse(userInfo.surveySettings.value)
			: userInfo.surveySettings;
	} else {
		return null;
	}
};

const onGetSystemPreferences = () => {
	return getUserPreference();
};

const isShowPriceOnDesign = () => {
	return onGetSystemPreferences()?.isShowPrice;
};
String.prototype.toProperCase = function () {
	return this.replace(/\w\S*/g, function (txt) {
		return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
	});
};

const validateEmail = (value) => {
	if (value) {
		let re =
			/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		if (!re.test(value)) {
			return false;
		}
	}
	return true;
};
const removeEmptyFilterParams = (filterParams) => {
	const results = {};
	for (const [key, value] of Object.entries(filterParams)) {
		if (value) {
			if (Array.isArray(value) && value.length !== 0) {
				results[key] = value;
			}
			if (!Array.isArray(value)) {
				results[key] = value;
			}
		}
	}
	return results;
};

const isValidLink = (str) => {
	const linkRegex = /^(https?:\/\/)?([a-z0-9.-]+\.[a-z]{2,})(:[0-9]+)?(\/[^?#]*)?(\\?[^#]*)?(#.*)?$/i;
	return linkRegex.test(str);
};

const sliderSettings = {
	dots: false,
	infinite: false,
	speed: 500,
	slidesToShow: 3,
	marginRight: 16,
	slidesToScroll: 3,
	initialSlide: 0,
	// centerMode: true,
	responsive: [
		{
			breakpoint: 1024,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 3,
				infinite: true,
				dots: true
			}
		},
		{
			breakpoint: 600,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 2,
				initialSlide: 2
			}
		},
		{
			breakpoint: 480,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1
			}
		}
	]
};

const encodeIpToken = (ipAddress) => {
	let formattedIp = ipAddress.replace('.', 'k').replace('.', 'm').replace('.', 'l');
	let userId = parseInt(getUserInfo().id);
	let p1 = btoa(userId * userId + userId).replaceAll('=', '');
	let p2 = btoa(formattedIp).replaceAll('=', '');
	let p3 = btoa(userId + 9999).replaceAll('=', '');
	return btoa(p1 + p2 + p3).replaceAll('=', '');
};

const printApiError = (error, timeOut = 5000) => {
	// Don't show toast errors during deployment
	if (deploymentDetector.isDeploying()) {
		return;
	}

	if (error?.response?.data?.message) {
		toastError(error.response.data.message, timeOut);
		// throw new Error(error.response.data.message);
	} else {
		toastError('Something went wrong!');
		// throw new Error('Something went wrong!');
	}
};

const insertAt = (array, index, ...elementsArray) => {
	array.splice(index, 0, ...elementsArray);
};

function concatenateArrayNTimes(array, n) {
	const result = [];
	for (let i = 0; i < n; i++) {
		result.push(...array);
	}
	return result;
}

const supplierCardRenderSequence = (totalElements) => {
	const chartToNum = {
		A: 1,
		B: 2,
		C: 3,
		D: 3
	};
	let sequence = [];
	let staticSequence = ['B', 'D', 'A', 'C', 'B', 'A', 'D', 'C'];
	let sequenceNumbers = concatenateArrayNTimes(staticSequence, Math.ceil(totalElements / 18));
	let sum = 0;
	for (let item of sequenceNumbers) {
		sum += chartToNum[item];
		if (sum <= totalElements) {
			sequence.push(item);
		} else {
			sum -= chartToNum[item];
		}
	}
	return sequence;
};
const checkIsValidImageAndSize = (files, size = 100) => {
	let totalSize = 0;
	let isValid = true;
	for (let i = 0; i < files.length; i++) {
		const file = files[i];
		totalSize += file.size;
	}
	if (totalSize > size * 1024 * 1024) {
		isValid = false;
		toastInfo(`You can upload maximum ${size}MB. For a larger file, upload it as a link.`);
	}
	return isValid;
};

const groupByKey = (array, property, sort) => {
	return array.reduce(function (acc, obj) {
		let key;
		if (sort === 'category') {
			key = obj.categoryResponse?.name || 'no_key';
		} else {
			key = property.split('.').reduce((acc, part) => acc && acc[part], obj) || 'no_key';
		}
		if (!acc[key]) {
			acc[key] = [];
		}
		acc[key].push(obj);
		return acc;
	}, {});
};

const getProductStatusWiseColor = {
	'Sample Requested': 'yellow-1 status-with-border',
	'Sample requested': 'yellow-1 status-with-border',
	Pattern: 'teal-1',
	Cutting: 'teal-1',
	Print: 'teal-1',
	Embroidery: 'teal-1',
	Sewing: 'teal-1',
	Wash: 'teal-1',
	Delivered: 'teal-1',
	'Handover to Factory': 'blue-1',
	'Received from factory': 'pink-1',
	'Send to Buyer': 'yellow-1',
	'Received by Buyer': 'brown-1',
	'Sample Approved by Buyer': 'green-2',
	'Sample Approved by AM': 'green-2',
	'Sample Rejected by Buyer': 'red-2',
	'Sample Rejected by AM': 'red-2',
	'Costing Requested': 'purple-1',
	'Costing Done': 'blue-1',
	'Offer Sent': 'yellow-1',
	'Costing Approved by Buyer': 'green-2',
	'Costing Approved by AM': 'green-2',
	'Costing Rejected by Buyer': 'red-2',
	'Costing Rejected by AM': 'red-2',
	Recosted: 'red-2',
	'PO Received': 'orange-1',
	'Supplier Assigned': 'green-1',
	Pending: 'purple-1',
	Production: 'yellow-1',
	'On Shipment': 'teal-1',
	'Shipment Completed': 'blue-1',
	'Cancel Request': 'red-2',
	Canceled: 'red-2',
	Techpack: 'blue-1',
	Development: 'yellow-1',
	Complete: 'green-1',
	Presentation: 'purple-1',
	Published: 'cyan-2',
	'Sample Closed': 'red-3',
	'Costing Closed': 'red-3'
};

const setTag = (className) => {
	return <span className={`status set ${className}`}>Set</span>;
};

const repeatTag = (className) => {
	return <span className={`status set ${className}`}>Repeat</span>;
};

const packTag = (className) => {
	return <span className={`status pack ${className}`}>Pack</span>;
};
const splitTag = (className) => {
	return <span className={`status yellow-1 ${className}`}>Split</span>;
};

const renderFabricColorAndSizeColumn = (fabricDetails) => {
	return (
		<ul key={fabricDetails.id} className="common-list-component align-items-center mb-2">
			<li className="d-flex align-items-center">
				{fabricDetails?.colorResponse?.hexCode ? (
					<span
						className="color-icon"
						style={{
							background: fabricDetails?.colorResponse?.hexCode
						}}
					/>
				) : (
					<span></span>
				)}
				<span className="ml-1">
					{fabricDetails?.colorResponse?.code || fabricDetails?.colorResponse?.name}
				</span>
			</li>
			{fabricDetails.size && fabricDetails.quantity && (
				<li>
					{fabricDetails.size} - {checkSingular('PCS', fabricDetails.quantity)}
				</li>
			)}
		</ul>
	);
};

const renderDesignDetails = (design, isSet, setMembersList = [], isPack, nameOfSet) => {
	return (
		<div className="ml-12">
			<div>
				{isSet && setTag()}
				{isPack && packTag()}
			</div>
			<p className="regular-12 gray_dark_01 py-1">{nameOfSet ? nameOfSet : design?.referenceNumber}</p>
			<ul className="common-list-component mb-2">
				{design?.market && <li>{design?.market}</li>}
				{!isSet && design.category && <li>{design?.category} </li>}
				{isSet && setMembersList.map((member) => <li key={member?.id}>{member?.category} </li>)}
			</ul>
			<ul className="common-list-component">
				{design?.productCreator && <li>{design?.productCreator}</li>}
				{design?.productCreationDate && (
					<li>{changeDateFormat(design?.productCreationDate, 'DD-MM-YYYY', 'Do MMM, YY')} </li>
				)}
			</ul>
		</div>
	);
};

const renderMaterialsList = (materials = []) => {
	return (
		<ul>
			{materials.map((material) => (
				<li key={_getKey()}>{material}</li>
			))}
		</ul>
	);
};

const renderSetImages = (images = [], width = '50px', onClick) => {
	return (
		<div className="set-image-layout" style={{ width }} onClick={() => (onClick ? onClick() : false)}>
			{images.slice(0, 2).map((image, index) => (
				<img
					key={index}
					src={image.docUrl || image.image || image.featureImageDocUrl}
					alt={`image ${index + 1}`}
					// className="cell-img pr-2"
				/>
			))}
		</div>
	);
};
const renderProductCreator = (product) => {
	return (
		<React.Fragment key={_getKey()}>
			{product?.productCreator && <li>{product?.productCreator}</li>}
			{product?.productCreationDate && (
				<li>{changeDateFormat(product?.productCreationDate, 'DD-MM-YYYY', 'Do MMM, YY')} </li>
			)}
		</React.Fragment>
	);
};

const renderSetItemDesingDetailsWithImage = (setMembersList = [], costingRequestDetails, productRefNo) => {
	return (
		<div className="d-flex align-items-center">
			<div className="set-image-layout" style={{ width: '56px' }}>
				{setMembersList &&
					setMembersList.length > 1 &&
					setMembersList
						.slice(0, 2)
						.map((image) => (
							<img
								key={image?.featureImageDocUrl}
								src={image?.featureImageDocUrl}
								alt="image"
								className="cell-img pr-2"
							/>
						))}
			</div>
			<div className="ml-12">
				{setTag()}
				<p className="regular-12 gray_dark_01 py-1">{productRefNo}</p>
				<ul className="common-list-component mb-2">
					<li>{setMembersList && setMembersList.length > 1 && setMembersList[0]?.market}</li>
					{setMembersList.map((category) => (
						<li key={setMembersList.id}>{category.category} </li>
					))}
				</ul>
				<ul className="common-list-component mb-2">
					{<li>{costingRequestDetails?.requestedBy}</li>}

					<li>{changeDateFormat(costingRequestDetails?.requestedDate, '', 'Do MMM, YY')}</li>
				</ul>
			</div>
		</div>
	);
};

const STATIC_SET_CONSTANTS = {
	SET_PRODUCT: 'SET_STYLE',
	SET_MEMBER: 'ADDED_IN_SET',
	PACK_PRODUCT: 'PACK_STYLE'
};

const getDateRange = (interval) => {
	const formatDate = (date) => (date ? date.toISOString() : null);
	const currentDate = new Date();
	let startDate, endDate;

	switch (interval) {
		case 'next7days':
			startDate = new Date(currentDate);
			endDate = new Date(currentDate);
			endDate.setDate(endDate.getDate() + 7);
			break;
		case 'next14days':
			startDate = new Date(currentDate);
			endDate = new Date(currentDate);
			endDate.setDate(endDate.getDate() + 14);
			break;
		case 'lastMonth':
			startDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
			endDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);
			break;
		case 'thisMonth':
			startDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
			endDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
			break;
		case 'nextMonth':
			startDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1);
			endDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 2, 0);
			break;
		case 'lastQuarter':
			startDate = new Date(
				currentDate.getFullYear(),
				Math.floor((currentDate.getMonth() - 3) / 3) * 3,
				1
			);
			endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 3, 0);
			break;
		case 'thisQuarter':
			startDate = new Date(currentDate.getFullYear(), Math.floor(currentDate.getMonth() / 3) * 3, 1);
			endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 3, 0);
			break;
		case 'nextQuarter':
			startDate = new Date(
				currentDate.getFullYear(),
				Math.ceil((currentDate.getMonth() + 1) / 3) * 3,
				1
			);
			endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 3, 0);
			break;
		case 'lastWeek':
			startDate = new Date(currentDate);
			startDate.setDate(startDate.getDate() - startDate.getDay() - 7);
			endDate = new Date(startDate);
			endDate.setDate(endDate.getDate() + 6);
			break;
		case 'thisWeek':
			startDate = new Date(currentDate);
			startDate.setDate(startDate.getDate() - startDate.getDay());
			endDate = new Date(startDate);
			endDate.setDate(endDate.getDate() + 6);
			break;
		case 'nextWeek':
			startDate = new Date(currentDate);
			startDate.setDate(startDate.getDate() - startDate.getDay() + 7);
			endDate = new Date(startDate);
			endDate.setDate(endDate.getDate() + 6);
			break;
		case 'lastYear':
			startDate = new Date(currentDate.getFullYear() - 1, 0, 1);
			endDate = new Date(currentDate.getFullYear() - 1, 11, 31);
			break;
		case 'thisYear':
			startDate = new Date(currentDate.getFullYear(), 0, 1);
			endDate = new Date(currentDate.getFullYear(), 11, 31);
			break;
		case 'nextYear':
			startDate = new Date(currentDate.getFullYear() + 1, 0, 1);
			endDate = new Date(currentDate.getFullYear() + 1, 11, 31);
			break;
		case 'oneYearBack':
			startDate = new Date(currentDate);
			startDate.setFullYear(startDate.getFullYear() - 1);
			endDate = new Date(currentDate);
			break;
		case 'lastOneMonth':
			startDate = new Date(currentDate);
			startDate.setMonth(currentDate.getMonth() - 1);
			endDate = new Date(currentDate);
			break;
		case 'lastOneYear':
			startDate = new Date(currentDate);
			startDate.setFullYear(currentDate.getFullYear() - 1);
			endDate = new Date(currentDate);
			break;
		case 'lastThreeYear':
			startDate = new Date(currentDate);
			startDate.setFullYear(currentDate.getFullYear() - 3);
			endDate = new Date(currentDate);
			break;
		case 'lastSixMonth':
			startDate = new Date(currentDate);
			startDate.setMonth(currentDate.getMonth() - 6);
			endDate = new Date(currentDate);
			break;
		case 'lastThreeMonth':
			startDate = new Date(currentDate);
			startDate.setMonth(currentDate.getMonth() - 3);
			endDate = new Date(currentDate);
			break;
		case 'lastSevenDays':
			startDate = new Date(currentDate);
			startDate.setDate(startDate.getDate() - 7);
			endDate = new Date(currentDate);
			break;
		case 'lastFourteenDays':
			startDate = new Date(currentDate);
			startDate.setDate(startDate.getDate() - 14);
			endDate = new Date(currentDate);
			break;

		case 'last7days':
			startDate = new Date(currentDate);
			startDate.setDate(currentDate.getDate() - 6);
			endDate = currentDate;
			break;
		case 'last14days':
			startDate = new Date(currentDate);
			startDate.setDate(currentDate.getDate() - 13);
			endDate = currentDate;
			break;
		case 'last30days':
			startDate = new Date(currentDate);
			startDate.setDate(currentDate.getDate() - 29);
			endDate = currentDate;
			break;
		case 'last12months':
			startDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 11, 1);
			endDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
			break;
		default:
			startDate = new Date(currentDate);
			endDate = new Date(currentDate);
			break;
	}

	return {
		start: formatDate(startDate),
		end: formatDate(endDate)
	};
};

const getSampleActivityStatus = (status) => {
	switch (status) {
		case 'SAMPLE_REQUESTED':
		case 'REQUESTED':
			return 'purple-1';
		case 'PATTERN':
		case 'CUTTING':
		case 'PRINT':
		case 'EMBROIDERY':
		case 'SEWING':
		case 'WASH':
		case 'DELIVERED':
		case 'ON_SHIPMENT':
			return 'teal-1';
		case 'HANDOVER_TO_FACTORY':
			return 'blue-1';
		case 'RECEIVED_FROM_FACTORY':
			return 'pink-1';
		case 'SAMPLE_APPROVED_BY_BUYER':
		case 'SAMPLE_APPROVED_BY_AM':
		case 'SHIPMENT_COMPLETED':
		case 'SUPPLIER_ASSIGNED':
			return 'green';
		case 'SEND_TO_BUYER':
		case 'PRODUCTION':
			return 'yellow-1';
		case 'RECEIVED_BY_BUYER':
			return 'brown-1';
		case 'SAMPLE_REJECTED_BY_BUYER':
		case 'SAMPLE_REJECTED_BY_AM':
		case 'CANCEL_REQUEST':
		case 'CANCELED':
			return 'red-2';
		case 'APPROVED':
			return 'green-2';
		case 'REJECTED':
			return 'red-2';
		case 'PENDING':
			return '';
		case 'CLOSED':
			return 'red-3';
		default:
			return '';
	}
};

const getCostingActivityStatus = (status, type) => {
	switch (status) {
		case 'INITIALIZED':
			return 'purple-1';
		case 'QUOTED':
			return 'blue-1';
		case 'OFFER_SENT':
			return 'yellow-1';
		case 'APPROVED':
			return type === 'TIMELINE_STATUS' ? 'green' : 'green-2';
		case 'REJECTED':
		case 'REQUEST_FOR_REVISION':
			return 'red-2';
		case 'ARCHIVE':
			return 'red-3';
	}
};

const getColorWiseActivityStatusOfCosting = (status, trimedStatus) => {
	return (
		<span className={`status ${getCostingActivityStatus(status, 'TABLE_STATUS')}`}>{trimedStatus}</span>
	);
};

const getColorWiseActivityStatusOfSample = (status, actiotnBy) => {
	const trimedStatus = replaceUnderLine(status);
	return (
		<span className={`status ${getSampleActivityStatus(status, 'TABLE_STATUS')}`}>
			{trimedStatus}
			{actiotnBy}
		</span>
	);
};

const getTodaysDate = () => new Date().toISOString().split('T')[0];

const getDesignAvailabilityStatus = (status) => {
	if (status === 'INITIAL') return 'initial';
	else if (status === 'DEVELOPMENT') return 'yellow-1';
	else if (status === 'COMPLETE') return 'green-1';
	else if (status === 'SOLD') return 'sold red';
	else if (status === 'PUBLISHED') return 'teal-1';
	else if (status === 'SENT_TO_BD') return 'sent-bd';
	else if (status === 'TECHPACK') return 'blue-1';
	else if (status === 'PRESENTATION') return 'purple-1';
	else if (status === 'ARCHIVED') return 'red-2';
	else if (status === 'ARCHIVED') return 'red-2';
	else if (status === 'Published') return 'cyan-2';
	else return 'yellow-1';
};

const getUniqueObjectsById = (objects) => {
	const uniqueObjects = {};
	objects.forEach((obj) => {
		uniqueObjects[obj.id] = obj;
	});
	return Object.values(uniqueObjects);
};

const getActionDoneBy = (userType) => {
	if (!userType) return '';
	if (userType === 'ACCOUNT_MANAGER') return ' by AM';
	return ' by Buyer';
};

const getCountryList = [
	{
		id: 16,
		name: 'Bangladesh'
	},
	{
		id: 237,
		name: 'Turkey'
	}
];
const parseAndRenderLinks = (text) => {
	if (!text) return '';

	const urlRegex = /(?:https?|ftp):\/\/[\n\S]+|www\.[\n\S]+/gi;

	let processedText = text.replace(urlRegex, (url) => {
		if (!url.match(/^[a-zA-Z]+:\/\//)) {
			url = 'https://' + url;
		}
		return `<a target="_blank" class="blue" href="${url.replace('</p>', '')}">${url}</a>`;
	});

	processedText = processedText.replace(/\n/g, '<br/>');

	return processedText;
};

const defaultDateRangePresets = [
	{ id: 'date-range-picker-input-1', interval: 'today', label: 'Today' },
	{ id: 'date-range-picker-input-2', interval: 'next7days', label: 'Next 7 days' },
	{ id: 'date-range-picker-input-3', interval: 'next14days', label: 'Next 14 days' },
	{ id: 'date-range-picker-input-4', interval: 'thisMonth', label: 'This Month' },
	{ id: 'date-range-picker-input-5', interval: 'nextMonth', label: 'Next Month' },
	{ id: 'date-range-picker-input-6', interval: 'thisQuarter', label: 'This Quarter' },
	{ id: 'date-range-picker-input-7', interval: 'nextQuarter', label: 'Next Quarter' }
];

const crmDateRangePresets = [
	{ id: 'date-range-picker-input-1', interval: 'lastWeek', label: 'Last Week' },
	{ id: 'date-range-picker-input-2', interval: 'thisWeek', label: 'This Week' },
	{ id: 'date-range-picker-input-3', interval: 'nextWeek', label: 'Next Week' },
	{ id: 'date-range-picker-input-4', interval: 'lastMonth', label: 'Last Month' },
	{ id: 'date-range-picker-input-5', interval: 'thisMonth', label: 'This Month' },
	{ id: 'date-range-picker-input-6', interval: 'nextMonth', label: 'Next Month' },
	{ id: 'date-range-picker-input-7', interval: 'lastQuarter', label: 'Last Quarter' },
	{ id: 'date-range-picker-input-8', interval: 'thisQuarter', label: 'This Quarter' },
	{ id: 'date-range-picker-input-9', interval: 'nextQuarter', label: 'Next Quarter' },
	{ id: 'date-range-picker-input-10', interval: 'lastYear', label: 'Last Year' },
	{ id: 'date-range-picker-input-11', interval: 'thisYear', label: 'This Year' },
	{ id: 'date-range-picker-input-12', interval: 'nextYear', label: 'Next Year' }
];

const collectionDateRangePresets = [
	{ id: 'date-range-picker-input-1', interval: 'today', label: 'Today' },
	{ id: 'date-range-picker-input-2', interval: 'last7days', label: 'Last 7 days' },
	{ id: 'date-range-picker-input-3', interval: 'last14days', label: 'Last 14 days' },
	{ id: 'date-range-picker-input-4', interval: 'last30days', label: 'Last 30 days' },
	{ id: 'date-range-picker-input-5', interval: 'thisQuarter', label: 'This Quarter' },
	{ id: 'date-range-picker-input-6', interval: 'lastQuarter', label: 'Last Quarter' },
	{ id: 'date-range-picker-input-7', interval: 'last12months', label: 'Last 12 month' }
];

const trendResearchDateRangePresets = [
	{ id: 'date-range-picker-input-1', interval: 'today', label: 'Today' },
	{ id: 'date-range-picker-input-2', interval: 'lastSevenDays', label: 'Last 7 days' },
	{ id: 'date-range-picker-input-3', interval: 'lastFourteenDays', label: 'Last 14 days' },
	{ id: 'date-range-picker-input-4', interval: 'lastOneMonth', label: 'Last 1 month' },
	{ id: 'date-range-picker-input-5', interval: 'lastThreeMonth', label: 'Last 3 months' },
	{ id: 'date-range-picker-input-6', interval: 'lastSixMonth', label: 'Last 6 months' },
	{ id: 'date-range-picker-input-7', interval: 'lastOneYear', label: 'Last 1 year' },
	{ id: 'date-range-picker-input-8', interval: 'lastThreeYear', label: 'Last 3 years' }
];

const insertSeparatorIfNeeded = (elementsArray = [], index, separator = ',') => {
	return elementsArray.length > 1 && elementsArray.length - 1 !== index ? separator : '';
};

const ORGANIZTION_INFO = getUserInfo()?.organization;

const MY_COLLEAGUES_TAGS_COLOR_CODE = [
	'#DBFFE5',
	'#FFEAEA',
	'#FBD9C2',
	'#FEEAC1',
	'#DFF2FF',
	'#EDE3FE',
	'#D0F0FD',
	'#F4DBE6',
	'#C2F5E9',
	'#EDDBD5'
];

const COUNTRY_CODES = [
	{
		code: 'BD',
		image: process.env.PUBLIC_URL + '/icons/flag/bd.svg'
	},
	{
		code: 'TR',
		image: process.env.PUBLIC_URL + '/icons/flag/turkey.svg'
	},
	{
		code: 'UK',
		image: process.env.PUBLIC_URL + '/icons/flag/uk.svg'
	},
	{
		code: 'ES',
		image: process.env.PUBLIC_URL + '/icons/flag/spain.svg'
	},
	{
		code: 'DE',
		image: process.env.PUBLIC_URL + '/icons/flag/germany.svg'
	},
	{
		code: 'US',
		image: process.env.PUBLIC_URL + '/icons/flag/us.svg'
	},
	{
		code: 'CN',
		image: process.env.PUBLIC_URL + '/icons/flag/china.svg'
	},
	{ code: 'GLOBAL', image: process.env.PUBLIC_URL + '/icons/flag/world.svg' }
];

const onMultipleFileUpload = (e, docType, onUploadDocuments) => {
	let files = [];
	let modifiedFileList = [];
	files = [...e.target.files];
	if (files.length !== 0) {
		files.forEach((file) => {
			if (file) {
				if (isValidFile(file, 'ALL', VALID_FILE_SIZE)) {
					let data = {
						uniqueId: generateRandomString(),
						name: file?.name,
						docMimeType: file?.type,
						documentType: docType,
						base64Str: ''
					};
					let reader = new FileReader();
					reader.readAsDataURL(file);
					reader.onload = () => {
						data.base64Str = reader.result;
						modifiedFileList.push(data);
					};
					reader.onerror = function (error) {
						toastError(error);
					};
				}
			}
		});
		setTimeout(() => {
			if (modifiedFileList?.length > 0) {
				onUploadDocuments(modifiedFileList);
			}
		}, 100);
	}
};

const formatFloatNumber = (value) => {
	return isNaN(Number(value)) ? '' : Number(value).toFixed(2);
};

const replaceSymbols = (inputString = '', symbolsToRemove, replacement = '') => {
	const regex = new RegExp(`[${symbolsToRemove}]`, 'g');
	return inputString.replace(regex, replacement);
};

const draftButtonHiddenStatuses = [
	'PO Received',
	'Supplier Assigned',
	'Production',
	'On Shipment',
	'Shipment Completed'
];

const getRequestFrom = () => {
	let searchField = window.location.search;
	let paramList = new URLSearchParams(searchField);
	return paramList.get('requestFrom');
};

const trendResearchColorSchema = [
	'#519DE9',
	'#EF9234',
	'#8481DD',
	'#73C5C5',
	'#C2D8FD',
	'#7CC674',
	'#F6D173',
	'#DBEB94',
	'#FCC5D3',
	'#F8E2E2',
	'#F0F0F0'
];

// Fisher-Yates shuffle
const randomShuffle = (arr) => {
	for (let i = arr.length - 1; i > 0; i--) {
		const j = Math.floor(Math.random() * (i + 1));
		[arr[i], arr[j]] = [arr[j], arr[i]];
	}
	return arr;
};

const processDecimalValue = (value) => {
	if (value == null || isNaN(value)) return '0.0';
	return value >= 10 ? parseFloat(Math.round(value)).toFixed(1) : parseFloat(value).toFixed(1);
};

const processTrendResearchDecimalValues = (data) => {
	const processedData = {};
	for (const [key, value] of Object.entries(data)) {
		processedData[key] = processDecimalValue(value);
	}
	return processedData;
};

// For RTK Query Download blob file
const downloadBlobFileWithRTKQuery = async (response, customFileName) => {
	try {
		let filename;
		if (customFileName) {
			filename = customFileName;
		} else {
			const contentDisposition =
				response.headers?.['content-disposition'] || response.headers?.get('content-disposition');

			if (contentDisposition) {
				const filenameMatch = contentDisposition.split('filename=')[1];
				filename = filenameMatch ? filenameMatch.replace(/["']/g, '') : null;
			}

			// If no filename found, create one with timestamp
			if (!filename) {
				const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
				filename = `download-${timestamp}.xlsx`;
			}
		}

		// Handle blob data
		let blob;
		if (response.data) {
			// Axios-like response
			blob = new Blob([response.data], { type: 'application/octet-stream' });
		} else {
			// Fetch API response
			blob = await response.blob();
		}

		// Create and trigger download
		const url = window.URL.createObjectURL(blob);
		const link = document.createElement('a');
		link.href = url;
		link.setAttribute('download', filename);
		document.body.appendChild(link);
		link.click();

		// Cleanup
		setTimeout(() => {
			link.remove();
			window.URL.revokeObjectURL(url);
		}, 100);

		return true;
	} catch (error) {
		throw error;
	}
};

const isSetProduct = (item) => {
	return item?.setPackStyleFlag === 'SET_STYLE';
};

const getLoadingState = (loadingStates = []) => {
	return loadingStates.some((state) => state === true);
};

const getErrorMessage = (errors = []) => {
	return errors
		.filter(Boolean)
		.map((error) => {
			// Handle different error structures
			if (typeof error === 'string') return error;
			// RTK Query fetchBaseQuery can return `{ error: "..." }`
			if (typeof error.error === 'string' && error.error.trim()) return error.error;

			// RTK Query can return `{ data: "plain text" }` or `{ data: "{\"message\":\"...\"}" }`
			if (typeof error.data === 'string') {
				const raw = error.data;
				try {
					const parsed = JSON.parse(raw);
					if (typeof parsed?.message === 'string' && parsed.message.trim()) return parsed.message;
					if (typeof parsed?.error === 'string' && parsed.error.trim()) return parsed.error;
				} catch {
					// Not JSON, treat as a plain text message
				}
				if (raw.trim()) return raw;
			}

			// Axios-like payloads sometimes nest error objects
			if (typeof error.data?.error === 'string' && error.data.error.trim()) return error.data.error;
			if (typeof error.data?.error?.message === 'string' && error.data.error.message.trim()) {
				return error.data.error.message;
			}
			if (error.message) return error.message;
			if (error.data?.message) return error.data.message;

			// If error has status code, include it in generic message
			if (error.status) {
				return `Request failed with status ${error.status}`;
			}

			return 'An unexpected error occurred';
		})
		.filter((message, index, array) => array.indexOf(message) === index);
};

const renderTextWithLinks = (text = '') => {
	const urlRegex = /(?:https?|ftp):\/\/[\n\S]+|www\.[\n\S]+/gi;

	let updatedText = text.replace(urlRegex, (url) => {
		let cleanedUrl = url.replace(/<\/?p>/g, '');
		if (!cleanedUrl.match(/^[a-zA-Z]+:\/\//)) {
			cleanedUrl = 'https://' + cleanedUrl;
		}
		return `<a href="${cleanedUrl}" target="_blank" rel="noopener noreferrer">${cleanedUrl}</a>`;
	});

	const parser = new DOMParser();
	const doc = parser.parseFromString(updatedText, 'text/html');

	doc.querySelectorAll('[data-denotation-char="#"]').forEach((mention) => {
		const id = mention.getAttribute('data-id');
		if (id) {
			mention.setAttribute('data-mention-id', id);
			mention.innerHTML = mention.innerHTML.replace(
				/class="ql-mention-denotation-char"/,
				'class="ql-mention-denotation-char" style="pointer-events: none;"'
			);
			mention.style.cursor = 'pointer';
		}
	});

	return doc.body.innerHTML;
};

const formatHtmlWithStyles = (html, styleList) => {
	const formatStyle = (style) => {
		const styleId = style.id;
		const styleRef = style.value;
		return (
			`<span class="mention" data-denotation-char="#" data-id="${styleId}" is-set="${style.isSet}">` +
			`<span contenteditable="false">` +
			`<span class="ql-mention-denotation-char">#</span>${styleRef}</span></span>`
		);
	};

	styleList.forEach((style) => {
		const regex = new RegExp(style.text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g');
		html = html.replace(regex, formatStyle(style));
	});

	return html;
};

const handleCopyToClipboard = (text, successMessage = 'Copied') => {
	navigator.clipboard.writeText(text);
	successMessage && toastSuccess(`${successMessage}`);
};

const adjustTextAreaHeight = (e, defaultHeight = '34px') => {
	e.target.style.height = 'auto';
	e.target.style.height = `${Math.max(e.target.scrollHeight, e.target.offsetHeight)}px`;
	if (!e.target.value) {
		e.target.style.height = defaultHeight;
	}
};

export const TASK_PRIORITY_CLASS_NAME = {
	STANDARD: 'status gray-1 status-with-border',
	HIGH: 'status yellow-1 status-with-border',
	EXPRESS: 'status red-3 status-with-border'
};

export {
	capitalizeFirstLetter,
	replaceSpace,
	validate,
	encodeQueryData,
	rfqStatus,
	rfqProductStatus,
	projectStatus,
	_getKey,
	clothingLabelStatus,
	addImageSuffix,
	convertTimeToLocal,
	getTimeCount,
	getMinsCountFromNow,
	getImageExt,
	IMAGE_EXTS,
	DOC_EXTS,
	XLS_EXTS,
	PDF_EXTS,
	getFileType,
	replaceUnderLine,
	changeDateFormat,
	isValidFile,
	isValidJSON,
	parseHtml,
	validateNumber,
	validateFloatNumber,
	getShortName,
	getNumberUnit,
	getDateDifference,
	generateFilterOptions,
	getUserInfo,
	isValidURL,
	isValidEmail,
	checkFileExtention,
	dateOrder,
	convertDateTimeToLocal,
	getIconByFileType,
	openNewWindow,
	checkPasswordStrength,
	parseQuoteName,
	checkSingular,
	findHeadingMaxLength,
	isPageReachBottom,
	renderMultiColor,
	downloadBlobFIle,
	onUploadFile,
	generateRandomString,
	toOrdinalSuffix,
	renderSwatchTypeColorsVertically,
	renderPantoneTypeColorsVertically,
	renderSwatchTypeColorsHorizontally,
	renderPantoneTypeColorsHorizontally,
	onErrorImageLoad,
	convertNumberToUSFormat,
	convertDateToLocal,
	onPreventDefaultAll,
	getMentionedUserIds,
	mentionModule,
	designToolRequiredTools,
	showTwoDecimalNumber,
	onImageLoadError,
	isPatternMaster,
	isSampleOrProductHead,
	getSampleStatus,
	isRequestFromSample,
	isRequestFromCosting,
	showDesignViewPage,
	sizeInMB,
	isRequestFromPhotography,
	ACCESS_TOKEN,
	getStompCLient,
	isValidInput,
	checkUserType,
	checkAnyUserType,
	checkHasUserType,
	addDataToArrayIndex,
	crmTabs,
	getDaysAgo,
	isShowPriceOnDesign,
	onGetSystemPreferences,
	onGetLocalFromUtc,
	getCollectionTimeCount,
	isDirector,
	isCRMManagement,
	validateEmail,
	removeEmptyFilterParams,
	isAdmin,
	isCRMAdmin,
	getPrimaryUserType,
	isValidLink,
	isFashionDesigner,
	sliderSettings,
	encodeIpToken,
	getUserPreference,
	printApiError,
	insertAt,
	checkIsValidImageAndSize,
	groupByKey,
	getProductStatusWiseColor,
	setTag,
	packTag,
	splitTag,
	renderDesignDetails,
	renderFabricColorAndSizeColumn,
	renderMaterialsList,
	renderSetImages,
	renderProductCreator,
	renderSetItemDesingDetailsWithImage,
	supplierCardRenderSequence,
	getAllMonthsList,
	getDateRange,
	STATIC_SET_CONSTANTS,
	getTodaysDate,
	getSampleActivityStatus,
	getColorWiseActivityStatusOfSample,
	getColorWiseActivityStatusOfCosting,
	getDesignAvailabilityStatus,
	getUniqueObjectsById,
	parseAndRenderLinks,
	getCostingActivityStatus,
	getActionDoneBy,
	checkPrimaryUserType,
	isAccountManager,
	ORGANIZTION_INFO,
	defaultDateRangePresets,
	crmDateRangePresets,
	getCountryList,
	insertSeparatorIfNeeded,
	getRequestFrom,
	MY_COLLEAGUES_TAGS_COLOR_CODE,
	COUNTRY_CODES,
	onMultipleFileUpload,
	formatFloatNumber,
	draftButtonHiddenStatuses,
	replaceSymbols,
	trendResearchColorSchema,
	randomShuffle,
	processTrendResearchDecimalValues,
	processDecimalValue,
	trendResearchDateRangePresets,
	collectionDateRangePresets,
	getDefaultMention,
	repeatTag,
	downloadBlobFileWithRTKQuery,
	isSetProduct,
	getLoadingState,
	getErrorMessage,
	getSurveySettings,
	renderTextWithLinks,
	formatHtmlWithStyles,
	handleCopyToClipboard,
	adjustTextAreaHeight
};
